if (!customElements.get('colagea-mobile-nav')) {
  customElements.define('colagea-mobile-nav', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { passive: true, signal: this.abort.signal };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const hero = document.querySelector('.sb-hero');
          const offers = document.querySelector('variant-selects');
          const buy = document.querySelector('product-form button[type="submit"]');
          this.hidden = !hero || !offers || !buy || innerWidth > 749 ||
            hero.getBoundingClientRect().bottom > 0 ||
            !(offers.getBoundingClientRect().top > innerHeight - 90 || buy.getBoundingClientRect().bottom < 0);
        });
      };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      this.querySelector('a').addEventListener('click', event => {
        const target = document.querySelector('variant-selects');
        if (!target) return;
        event.preventDefault();
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }, { signal: this.abort.signal });
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

